<template>
  <div class="bjdCodeSelectContainer">
    <div
        v-if="!selectButton"
        class="titleContainer"
    >
      <div class="filterTitle">지역필터️</div>
      <div class="filterDesc">⚠ 종합분석에만 적용되며 점진적으로 확대 예정입니다.</div>
    </div>
    <div
        class="selectContainer"
    >
      <v-select
          v-if="useSise === true"
          v-model="selectedPriceType"
          :items="priceTypes"
          label="기반 시세"
          item-text="name"
          item-value="value"
          no-data-text=""
          dense
          class="selector"
          outlined
          hide-details
          @change="priceTypeChanged"
        ></v-select>
      <v-select
          v-if="bjdLevel === 'sd' || bjdLevel === 'sgg' || bjdLevel === 'emd'"
          v-model="selectedSd"
          :items="sd"
          label="시도 (인구수)"
          item-text="name"
          item-value="bjdCode"
          no-data-text=""
          dense
          class="selector"
          outlined
          hide-details
          @change="sdChanged"
      ></v-select>

      <v-select
          v-if="bjdLevel === 'sgg' || bjdLevel === 'emd'"
          v-model="selectedSgg"
          :items="sgg"
          label="시군구 (인구수)"
          placeholder="시군구"
          dense
          class="selector"
          no-data-text="시도를 선택헤주세요."
          item-text="name"
          item-value="bjdCode"
          outlined
          hide-details
          @change="sggChanged"
      ></v-select>
      <v-select
          v-if="bjdLevel === 'emd'"
          v-model="selectedEmd"
          :items="emd"
          label="읍면동 (인구수)"
          placeholder="읍면동"
          dense
          no-data-text="시군구를 선택헤주세요."
          class="selector"
          item-text="name"
          item-value="bjdCode"
          outlined
          hide-details
          @change="emdChanged"
      ></v-select>
      <v-btn
          v-if="selectButton"
          style="margin-left:10px;"
          small
          @click.stop="onClickSelect"
      >
        적용
      </v-btn>
      <v-btn
          style="margin-left: 10px;"
          small
          @click.stop="onClickClear"
      >
        초기화
      </v-btn>
    </div>
  </div>

</template>

<script>
import {api} from "../../mixins/api";
import {mapMutations, mapState} from "vuex";

export default {
  props: {
    selectButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    onClickSelect: {
      type: Function,
    },
    useSise: {
      type: Boolean,
      default() {
        return true;
      }
    },
    bjdLevel: {
      type: String,
      required: true,
      validator: function (value) {
        return ['sd', 'sgg', 'emd'].includes(value);
      },
      default() {
        return 'emd';
      }
    }
  },
  name: "BjdCodeSelectComponent",
  data() {
    return {
      priceTypes: [
        { name: '리치고 시세 기반', value: 'richgo'},
        { name: 'kb 시세 기반', value: 'kb'},
      ],
      selectedPriceType: 'richgo',
      sd: null,
      selectedSd: null,
      sgg: [],
      selectedSgg: null,
      emd: [],
      selectedEmd: null,
    }
  },
  computed: {
    ...mapState(["bjdInfo", "priceType"])
  },
  watch: {
    'bjdInfo.bjdCode': {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initializeSelectsBasedOnBjdCode(newVal);
        }
      }
    },
    'priceType': {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initializePriceType(newVal);
        }
      }
    }
  },
  async created() {
    this.initializePriceType();
    await this.initializeSelects();
  },
  methods: {
    ...mapMutations(["setBjdInfo", "setPriceType"]),
    async initializeSelects() {
      await this.getSd();

      const bjdInfo = localStorage.getItem("BJD_INFO_LS");
      if (bjdInfo && JSON.stringify(this.bjdInfo) !== JSON.stringify(bjdInfo)) {
        this.setBjdInfo(JSON.parse(bjdInfo));
      }

      await this.initializeSelectsBasedOnBjdCode(this.bjdInfo.bjdCode);
    },
    initializePriceType(priceType) {
      if (!priceType) {
        var v = localStorage.getItem("PRICE_TYPE_LS");
        if (v && v !== this.selectedPriceType) {
          this.selectedPriceType = v;
        }
        return;
      }

      this.selectedPriceType = priceType;
    },
    async initializeSelectsBasedOnBjdCode(bjdCode) {
      if (!bjdCode) {
        return;
      }

      const bjdCheck = (code, count) => {
        const zeros = '0'.repeat(count);
        return code.slice(-count) === zeros;
      }

      const getBjdCodeWithPadding = (bjdCode, count) => {
        return bjdCode.slice(0, count) + "0".repeat(bjdCode.length - count)
      }

      this.selectedSd = null;
      this.selectedSgg = null;
      this.selectedEmd = null;
      this.sd = [];
      this.sgg = [];
      this.emd = [];

      await this.getSd();

      // 법정동 코드를 까서 현재 선택된 시도/시군구/읍면동을 다시 셋팅해준다.
      if (bjdCheck(bjdCode, 10)) {
        // 전국
        // do nothing
      } else if (bjdCheck(bjdCode, 8)) {
        // 시도
        this.selectedSd = getBjdCodeWithPadding(bjdCode, 2);
        await this.getSgg();
      } else if (bjdCheck(bjdCode, 5)) {
        // 시군구
        this.selectedSd = getBjdCodeWithPadding(bjdCode, 2);
        await this.getSgg();
        this.selectedSgg = getBjdCodeWithPadding(bjdCode, 5);
        await this.getEmd();
      } else {
        // 읍면동
        this.selectedSd = getBjdCodeWithPadding(bjdCode, 2);
        await this.getSgg();
        this.selectedSgg = getBjdCodeWithPadding(bjdCode, 5);
        await this.getEmd();
        this.selectedEmd = bjdCode;
      }
    },
    priceTypeChanged(priceType) {
      this.setPriceType(priceType);
      this.selectedPriceType = priceType;
    },
    async sdChanged(bjdCode) {
      this.setBjdInfo({
        'sd': this.sd.filter(x => x.bjdCode === bjdCode)[0].name,
        'sgg': null,
        'emd': null,
        'bjdCode': bjdCode
      });

      this.sgg = [];
      this.emd = [];
      await this.getSgg();
    },
    async sggChanged(bjdCode) {
      this.setBjdInfo({
        'sd': this.bjdInfo.sd,
        'sgg': this.sgg.filter(x => x.bjdCode === bjdCode)[0].name,
        'emd': null,
        'bjdCode': bjdCode
      });

      this.emd = [];
      await this.getEmd();
    },
    async emdChanged(bjdCode) {
      this.setBjdInfo({
        'sd': this.bjdInfo.sd,
        'sgg': this.bjdInfo.sgg,
        'emd': this.emd.filter(x => x.bjdCode === bjdCode)[0].name,
        'bjdCode': bjdCode
      });
    },
    async getSd() {
      let response = await api.methods.getAreaV2Api("0000000000");

      // 서울, 경기, 인천, 가나다 순으로 보여준다.
      let sublist = [
        {
          "bjdCode": "1100000000",
          "name": response.sublist.find(item => item.bjdCode === "1100000000").name,
          "sublist": null
        },
        {
          "bjdCode": "4100000000",
          "name": response.sublist.find(item => item.bjdCode === "4100000000").name,
          "sublist": null
        },
        {
          "bjdCode": "2800000000",
          "name": response.sublist.find(item => item.bjdCode === "2800000000").name,
          "sublist": null
        },
      ]

      const filteredList = response.sublist.filter(item => item.name !== "서울" && item.name !== "경기" && item.name !== "인천");
      filteredList.sort((a, b) => {
        const nameA = a.name;
        const nameB = b.name;
        return nameA.localeCompare(nameB);
      });
      sublist = sublist.concat(filteredList);
      this.sd = sublist;
    },
    async getSgg() {
      let response = await api.methods.getAreaV2Api(this.selectedSd);
      response.sublist.sort((a, b) => {
        const nameA = a.name;
        const nameB = b.name;
        return nameA.localeCompare(nameB);
      })
      this.sgg = response.sublist;
    },
    async getEmd() {
      let response = await api.methods.getAreaV2Api(this.selectedSgg);
      response.sublist.sort((a, b) => {
        const nameA = a.name;
        const nameB = b.name;
        return nameA.localeCompare(nameB);
      })
      this.emd = response.sublist;
    },
    async onClickClear() {
      this.selectedSd = null;
      this.selectedSgg = null;
      this.selectedEmd = null;
      this.sd = [];
      this.sgg = [];
      this.emd = [];

      this.setBjdInfo({
        'sd': null,
        'sgg': null,
        'emd': null,
        'bjdCode': '0000000000'
      })

      this.selectedPriceType = 'richgo';
      this.setPriceType('richgo');

      await this.getSd();
    }
  }
}
</script>

<style scoped>
.bjdCodeSelectContainer {
  margin-left: 16px;
  margin-bottom: 10px;
}
.titleContainer {
  margin-left: 2px;

}

.filterTitle {
  display: inline-block;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.4px;
  margin-right: 22px;
}

.filterDesc {
  display: inline-block;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.4px;
}

.selector {
  display: inline-block;
  width: 180px;
  height: 38px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.4px;
  text-align: center;
}

.selectContainer {
  margin-top: 17px;
}

</style>
